import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../../shared/user/user';

@Injectable()
export class UsersService {
  constructor(private http: HttpClient) {}

  users() {
    return this.http.get('/users');
  }

  usersSimplified() {
    return this.http.get('/users/registered/simplified');
  }

  getAccounts() {
    return this.http.get('/users/domains');
  }

  getAssignedUsersForMsisdn(msisdnId: string) {
    return this.http.get<User[]>(`/inbound/configuration/numbers/${msisdnId}/assigned-users`);
  }

  getUnassignedUsersForMsisdn(msisdnId: string) {
    return this.http.get<User[]>(`/inbound/configuration/numbers/${msisdnId}/unassigned-users`);
  }

  assignUserToMsisdn(msisdnId: string, userId: string) {
    return this.http.post(`/inbound/configuration/numbers/${msisdnId}/users/${userId}`, {});
  }

  unassignUserFromMsisdn(msisdnId: string, userId: string) {
    return this.http.delete(`/inbound/configuration/numbers/${msisdnId}/users/${userId}`);
  }

  assignUsersToMsisdn(msisdnId: string, userIds: number[]) {
    return this.http.post(`/inbound/configuration/numbers/${msisdnId}/users`, userIds);
  }
}
